import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaWhatsapp } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Contact.css';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [apiResponse, setApiResponse] = useState<any>(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    setApiResponse(null);

    try {
      const response = await fetch('http://localhost/mrcentrifugas-react/api/contacts.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setSubmitStatus('success');
        setApiResponse(result);
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
        console.log('Resposta da API:', result);
      } else {
        setSubmitStatus('error');
        setApiResponse(result);
        console.error('Erro:', result.error);
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error('Erro de conexão:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: 'Endereço',
      content: 'Rua Manuel de Teffé 417, Jardim Satélite, São Paulo - SP'
    },
    {
      icon: <FaPhone />,
      title: 'Telefone',
      content: '(11) 5660-6431 / (11) 99780-8507'
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      content: 'contato@mrcentrifugas.com.br'
    },
    {
      icon: <FaClock />,
      title: 'Horário de Atendimento',
      content: 'Segunda a Sexta: 8h às 18h'
    }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="page-hero">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} data-aos="fade-up">
              <h1>Entre em Contato</h1>
              <p>
                Estamos prontos para atender você e fornecer a melhor solução
                para suas necessidades. Entre em contato conosco.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Section */}
      <section className="section contact-section">
        <Container>
          <Row>
            {/* Contact Form */}
            <Col lg={8} data-aos="fade-right">
              <div className="contact-form-container">
                <h2>Envie sua Mensagem</h2>
                <p className="form-description">
                  Preencha o formulário abaixo e nossa equipe entrará em contato
                  o mais breve possível.
                </p>

                {submitStatus === 'success' && (
                  <Alert variant="success" className="mb-4">
                    <h5>✅ Mensagem enviada com sucesso!</h5>
                    <p className="mb-0">
                      Sua mensagem foi recebida e salva em nosso sistema.
                      Em breve você receberá um email de confirmação e nossa equipe entrará em contato.
                    </p>
                    <small className="text-muted">
                      ID do contato: {apiResponse?.id} | Email enviado: {apiResponse?.email_sent ? 'Sim' : 'Em breve'}
                    </small>
                  </Alert>
                )}

                {submitStatus === 'error' && (
                  <Alert variant="danger" className="mb-4">
                    Erro ao enviar mensagem. Tente novamente ou entre em contato por telefone.
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Nome Completo *</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                          placeholder="Digite seu nome completo"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          placeholder="Digite seu email"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Telefone</Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="Digite seu telefone"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Assunto *</Form.Label>
                        <Form.Control
                          type="text"
                          name="subject"
                          value={formData.subject}
                          onChange={handleInputChange}
                          required
                          placeholder="Digite o assunto"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <Form.Label>Mensagem *</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      placeholder="Digite sua mensagem..."
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    className="btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
                  </Button>
                </Form>
              </div>
            </Col>

            {/* Contact Info */}
            <Col lg={4} data-aos="fade-left">
              <div className="contact-info-container">
                <h3>Informações de Contato</h3>
                <p>Entre em contato conosco através dos canais abaixo:</p>

                <div className="contact-info-list">
                  {contactInfo.map((info, index) => (
                    <div key={index} className="contact-info-item">
                      <div className="contact-icon">
                        {info.icon}
                      </div>
                      <div className="contact-details">
                        <h5>{info.title}</h5>
                        <p>{info.content}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="whatsapp-cta">
                  <h4>Atendimento Rápido</h4>
                  <p>Precisa de um orçamento urgente?</p>
                  <a
                    href="https://wa.me/5511997808507"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success btn-lg"
                  >
                    <FaWhatsapp className="me-2" />
                    WhatsApp
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Map Section */}
      <section className="section map-section">
        <Container>
          <div className="section-title" data-aos="fade-up">
            <h2>Nossa Localização</h2>
            <p>Visite nossa sede em São Paulo</p>
          </div>

          <Row className="justify-content-center">
            <Col lg={10} data-aos="fade-up">
              <div className="map-container">
                <div className="map-placeholder">
                  <div className="map-info">
                    <h4>MR Centrifugas</h4>
                    <p>Rua Manuel de Teffé, 417 - Jardim Satelite</p>
                    <p>São Paulo - SP, 04815-300</p>
                    <a
                      href="https://www.google.com/maps/place/Rua+Manuel+de+Teff%C3%A9,+417+-+Jardim+Satelite,+S%C3%A3o+Paulo+-+SP,+04815-300/@-23.698866,-46.6926631,17z/data=!3m1!4b1!4m6!3m5!1s0x94ce4fc1058d1d77:0xaae0f3e92188f5ba!8m2!3d-23.698866!4d-46.6926631!16s%2Fg%2F11c2f06zkk?entry=ttu"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      <i className="fas fa-map-marker-alt me-2"></i>
                      Ver no Google Maps
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} data-aos="fade-up">
              <h2>Precisa de um orçamento urgente?</h2>
              <p>
                Nossa equipe está pronta para atender você 24/7.
                Entre em contato agora mesmo!
              </p>
              <div className="cta-buttons">
                <a href="tel:+5511997808507" className="btn btn-primary btn-lg me-3">
                  Ligar Agora
                </a>
                <a
                  href="https://wa.me/5511997808507"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success btn-lg"
                >
                  <FaWhatsapp className="me-2" />
                  WhatsApp
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Contact; 